import { EventPayload } from '../../../../../types/GTM/EventPayload';
import { NAFGTMEvent } from '../../../../../types/GTM/NAFGTMEvent';
import { ECommerceItem } from '../../../../../types/GTM/ECommerceItem';
import { createEventPayload } from '../../../hooks/GTM/useSendGTMEventOnce';
import { getPromotionDataFromSessionStorage } from '../../../hooks/useTrackPromotion';

const CHECKOUT_REGISTRATION_METHOD_KEY = 'checkout_registration_method';

export interface AddPaymentInfoParams {
  dataLayer: EventPayload[] | null;
  items: ECommerceItem[];
  value: number;
  checkoutRegistrationMethod?: EventPayload['checkout_registration_method'];
  campaignCode?: string;
}

export const sendAddPaymentInfoEvent = ({
  dataLayer,
  items,
  value,
  checkoutRegistrationMethod,
  campaignCode,
}: AddPaymentInfoParams): void => {
  if (!dataLayer || !items || items.length === 0 || value === undefined || value === null) {
    return;
  }
  const promotionData = getPromotionDataFromSessionStorage();
  const itemsWithPromotion = promotionData ? items.map((item) => ({ ...item, ...promotionData })) : items;

  const eventPayload = createEventPayload({
    event: NAFGTMEvent.addPaymentInfo,
    ...(checkoutRegistrationMethod && { [CHECKOUT_REGISTRATION_METHOD_KEY]: checkoutRegistrationMethod }),
    ...(campaignCode && { campaign_code: campaignCode }),
    ecommerce: {
      value,
      items: itemsWithPromotion,
    },
  });

  dataLayer.push(eventPayload);
};
